import React, { useState } from "react";
import { Link } from "react-router-dom";
import AfcImage from './AfcPic.jpg';
import IconSocalFursDate from './SocalDate.jpg';
import IconSocalFurs from './Socalfurs.jpg';
import { BrowserRouter as Router, Routes, Route,useLocation } from "react-router-dom"
import "./HomePage.css";
import SocialGroupLinkButton from "../components/SocialGroupLinkButton";
//commit
// test


export default function HomePage() {


    return (
 
        <div className="homepage-image-container">
      
            {/* <div className = "highlight-info-container">
            <p className = "highlight-info-text"> <strong><Link to = "/about-us">Welcome Socal Furs! </Link></strong>
             Just a quick heads-up: we’ll soon be moving to our new domain at <strong><a href = "socalfurs.com">socalfurs.com</a></strong>. 
            That means this current site may eventually redirect or go offline.Keep an eye out for the change, 
            and be sure to bookmark the new address so you don’t 
            miss any updates about local furry meetups in Southern California, site news, or upcoming 
            events near you.
            We're a local community hub for furries, artists, fursuiters, and fans of anthropomorphic art and culture. 
            Whether you're brand new or have been part of the fandom for years, we're glad you're here!

              </p>
          </div> */}

            <div className="homepage-welcome-container">
                <img className="homepage-main-icon" src={AfcImage} alt="Socalfurs.com" />

                <div className="homepage-welcome-content">
                    <div className="homepage-welcome-text">
                        <header className="homepage-welcome-header">Welcome to SocalFurs</header>
                        <p className="homepage-welcome-p">
                            {/* Welcome to SoCalFurs.com!
                            We're a local community calendar of events hub for Southern California
                            based hobbyists, costumers, artists and furry fans of anthropomorphic art
                            and culture. Whether you're brand new or have been part of the fandom for
                            years, we're glad you're here! */}


                            We're a welcoming community of Southern California
                            based hobbyists, cosplayers, artists, and many other fans of anthropomorphic art
                            and culture. We're glad you're here!
                        
                        </p>
                   

                        <p className="homepage-welcome-p1"> Your gateway
                            into our local furry community!
                        </p>
                             <p> - Photo by <Link to ="https://chaiwolfessphotography.smugmug.com/">Chai Wolfess Photography</Link>
                        </p>

                        <div className="homepage-button-group">
                            <a href="#calendar"><button className="primary">See the Calendar ➜</button></a>
                            <a href="#groups"><button className="secondary">Join our Groups ➜</button></a>
                        </div>
                        <div className="homepage-button-group">
                                
                                 <a href="/events/map"><button className="">Socal Event Map Viewer ➜</button></a>
                        </div> 
                          
                    </div>
                </div>
            </div>

            <div className="calendar-container" id="calendar">
                <h1>Upcoming SocalFurs Events</h1>   
                   <p className = "calendar-p">
                            <strong>Dislcaimer:</strong> Event times and listings on this calendar are subject to change. 
                            Some events may be moved or canceled, and these updates may not always be reflected on the 
                            calendar in real time. For the most accurate and up-to-date information, please consider joining 
                            the <a href = "https://t.me/+LPKHccQiNR03ZDQ7">Telegram group.</a></p>
                <SocialGroupLinkButton type="map" />
            

                <div className="calendar-embed-container">
                    <iframe
                        title="Furry Events Calendar"
                        src="https://calendar.google.com/calendar/embed?src=1cdf9a4e9629d0b119d4daaa0e8ad0cc4d490b3cf95d458b0bf7247e323fb05e%40group.calendar.google.com&ctz=America/Los_Angeles"
                        className="calendar-src"
                        frameBorder="0"
                    ></iframe>
                </div>
         
              
            </div>

            <div id="groups"></div>
            <div className="socials">
                <h1 style={{textAlign: 'center'}}>SocalFurs Social Media Groups</h1>
                <p style={{padding: "16px 0"}}>
                    Our online groups are the fastest way to find out about events and interact with other furries near you!
                    It is highly recommended that you join some of these groups if you would like to be active in the community.
                </p>

                <div style={{ display: 'flex', gap: 12, marginBottom:8 }}>
                    <SocialGroupLinkButton type="telegram" />
                    <SocialGroupLinkButton type="discord" />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: 8 }}>
                    <em>or</em>
                    <Link to="/groups" style={{textDecoration: 'none'}}>
                        <button
                            style={{
                                border: 'none',
                                backgroundColor: 'white',
                                color: 'black',
                                padding: '8px 12px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 8,
                            }}
                        >
                            More Groups Info ➜
                        </button>
                    </Link>
                </div>
                
            </div>


            <h1 style={{textAlign: 'center', marginTop: 44}}>About</h1>
            <div className="faq-section">
                <div className="faq-content">
                    <strong>Discover Local Furry Meetups and Events</strong>

                    <p>
                        Established in 2001, <Link to ="/about">SocalFurs</Link> is a community-driven hub dedicated to helping you discover and attend furry events near you. From weekly furry meetups in Los Angeles, Orange County to monthly fursuit hangs in San Diego, we list it all in one place. Our site brings you the latest on:
                    </p>
                    <ul>
                        <li>Furry conventions and mini-cons</li>
                        <li>Local furry gatherings in parks or cafes</li>
                        <li>Artist meetups and fursona drawing nights</li>
                        <li>Fursuit-friendly public events</li>
                        <li>Holiday-themed and seasonal furmeets</li>
                        <li>Adults only (AD) meets</li>
                    </ul>

                    <p>
                        No matter where you’re located in SoCal — be it Long Beach, Santa Ana, Ontario, or Pasadena — you’ll find events tailored to your area. We’re here to keep the SoCal furry scene connected. If
                        you are new click here to for info on <Link to ="/events">How To Attend A Furry Meet!</Link> 
                    </p>
                    
                </div>
                <img className="what-is-main-icon" src={IconSocalFursDate} alt="Socalfurs Event Calendar" />
            </div>

            <div className="faq-section">
                <div className="faq-content">
                    <strong>What the heck is a furry?</strong>
                    <p>
                        A furry is someone who has an interest in anthropomorphic animals—animals that are given human-like qualities,
                        such as the ability to speak, walk on two legs, or wear clothing.
                        This interest can be expressed through various forms of art, storytelling, and roleplaying.
                        Many furries enjoy creating and wearing costumes (called fursuits) that represent anthropomorphic animal characters,
                        allowing them to step into the shoes of their favorite creatures. The furry community is diverse and inclusive,
                        bringing together people who share a love for creativity, imagination, and self-expression.
                        It’s more than just dressing up in animal costumes; it’s a vibrant subculture where people connect,
                        create, and celebrate their shared interests, often through conventions, online communities, and social events.
                        Being a furry means embracing individuality and having fun.
                    </p>
                </div>
                <img className="what-is-main-icon" src={IconSocalFurs} alt="Socalfurs.com" />
            </div>


            <div className="space"></div>

        


            {/* End of entire div */}
        </div>
    );
}
